module.exports = __webpack_public_path__ + "static/media/friends.ea0d6b55.svg";